import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { UserSystemAnnouncement } from 'app/api/models';
import { NotificationService } from 'app/api/services';

@Component({
  selector: 'app-system-announcements-dialog',
  templateUrl: './system-announcements-dialog.component.html',
  styleUrls: ['./system-announcements-dialog.component.css']
})
export class SystemAnnouncementsDialogComponent {
  step = 0;
  isLoading = false;
  @ViewChild('sliderEl', { static: true }) sliderEl!: HTMLDivElement;

  constructor(
    private dialogRef: MatDialogRef<SystemAnnouncementsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public announcements: UserSystemAnnouncement[],
    private notificationService: NotificationService
  ) {
    // console.log('this.announcements :>> ', this.announcements);
  }

  get announcementCount(): number {
    return this.announcements.length || 0;
  }

  get selectedAnnouncement(): UserSystemAnnouncement | null {
    return this.announcements.length > 0 ? this.announcements[this.step] : null;
  }

  scrollLeft(sliderEl: HTMLDivElement) {
    if (this.step <= 0) return;
    this.step -= 1;
    sliderEl.scrollLeft = this.step * sliderEl.offsetWidth;
  }

  scrollRight(sliderEl: HTMLDivElement) {
    if (this.step >= this.announcementCount - 1) return;
    this.step += 1;
    sliderEl.scrollLeft = this.step * sliderEl.offsetWidth;
  }

  onDotClick(index: number, sliderEl: HTMLDivElement) {
    this.step = index;
    sliderEl.scrollLeft = this.step * sliderEl.offsetWidth;
  }

  markAsRead() {
    if (!this.selectedAnnouncement) return;

    const selectedId = this.selectedAnnouncement.systemAnnouncementId;
    this.notificationService
      .markSystemAnnouncementAsRead(selectedId)
      .subscribe({
        next: () => {
          this.announcements[this.step].isRead = true;
        },
        error: (err) => {
          console.error('Failed to mark announcement as read: ', err);
        }
      });
  }

  onClose() {
    this.dialogRef.close();
  }
}
